__turbopack_context__.v({
  "_10": "_22Z_9G__10",
  "_11": "_22Z_9G__11",
  "_12": "_22Z_9G__12",
  "_13": "_22Z_9G__13",
  "_14": "_22Z_9G__14",
  "_15": "_22Z_9G__15",
  "_16": "_22Z_9G__16",
  "_17": "_22Z_9G__17",
  "_18": "_22Z_9G__18",
  "_19": "_22Z_9G__19",
  "_20": "_22Z_9G__20",
  "_21": "_22Z_9G__21",
  "_22": "_22Z_9G__22",
  "_23": "_22Z_9G__23",
  "_24": "_22Z_9G__24",
  "_25": "_22Z_9G__25",
  "_26": "_22Z_9G__26",
  "_27": "_22Z_9G__27",
  "_28": "_22Z_9G__28",
  "_5": "_22Z_9G__5",
  "_6": "_22Z_9G__6",
  "_7": "_22Z_9G__7",
  "_8": "_22Z_9G__8",
  "_9": "_22Z_9G__9",
  "actions": "_22Z_9G_actions",
  "actions2": "_22Z_9G_actions2",
  "actions3": "_22Z_9G_actions3",
  "banner": "_22Z_9G_banner",
  "banner2": "_22Z_9G_banner2",
  "banner3": "_22Z_9G_banner3",
  "body": "_22Z_9G_body",
  "body2": "_22Z_9G_body2",
  "body3": "_22Z_9G_body3",
  "body5": "_22Z_9G_body5",
  "body6": "_22Z_9G_body6",
  "body7": "_22Z_9G_body7",
  "body8": "_22Z_9G_body8",
  "body9": "_22Z_9G_body9",
  "clients": "_22Z_9G_clients",
  "clients2": "_22Z_9G_clients2",
  "clients3": "_22Z_9G_clients3",
  "col": "_22Z_9G_col",
  "col2": "_22Z_9G_col2",
  "desktop": "_22Z_9G_desktop",
  "desktopMockup": "_22Z_9G_desktopMockup",
  "desktopMockup2": "_22Z_9G_desktopMockup2",
  "left2": "_22Z_9G_left2",
  "mobile": "_22Z_9G_mobile",
  "requestDemo": "_22Z_9G_requestDemo",
  "requestDemo2": "_22Z_9G_requestDemo2",
  "requestDemo3": "_22Z_9G_requestDemo3",
  "right2": "_22Z_9G_right2",
  "row": "_22Z_9G_row",
  "row2": "_22Z_9G_row2",
  "row3": "_22Z_9G_row3",
  "row4": "_22Z_9G_row4",
  "row5": "_22Z_9G_row5",
  "rows": "_22Z_9G_rows",
  "rows2": "_22Z_9G_rows2",
  "sectionHeader": "_22Z_9G_sectionHeader",
  "sectionHeader2": "_22Z_9G_sectionHeader2",
  "sectionHeader3": "_22Z_9G_sectionHeader3",
  "subtitle": "_22Z_9G_subtitle",
  "subtitle2": "_22Z_9G_subtitle2",
  "subtitle3": "_22Z_9G_subtitle3",
  "svg__dDqqW": "_22Z_9G_svg__dDqqW",
  "svg__iXtQ3": "_22Z_9G_svg__iXtQ3",
  "svg__nsMuy": "_22Z_9G_svg__nsMuy",
  "svg__ntByb": "_22Z_9G_svg__ntByb",
  "svg__rb8Rq": "_22Z_9G_svg__rb8Rq",
  "svg__vDJkh": "_22Z_9G_svg__vDJkh",
  "tablet": "_22Z_9G_tablet",
  "text__mYwe3": "_22Z_9G_text__mYwe3",
  "text__qmkHk": "_22Z_9G_text__qmkHk",
  "text__tsJ9B": "_22Z_9G_text__tsJ9B",
  "text__w7Wlh": "_22Z_9G_text__w7Wlh",
  "title": "_22Z_9G_title",
  "title2": "_22Z_9G_title2",
  "title3": "_22Z_9G_title3",
  "top": "_22Z_9G_top",
  "top2": "_22Z_9G_top2",
  "top3": "_22Z_9G_top3",
  "top4": "_22Z_9G_top4",
  "topSection": "_22Z_9G_topSection",
  "wrapper": "_22Z_9G_wrapper",
  "wrapper2": "_22Z_9G_wrapper2",
  "wrapper3": "_22Z_9G_wrapper3",
  "wrapper4": "_22Z_9G_wrapper4",
});
